import React, { FC } from 'react';
import styled from 'styled-components';

import { SBPMethod } from '~/api/finance/financeApiTypes';
import {
  DefaultMethodPaymentParams,
  MethodPaymentTemplate,
} from '~/feature/finance/BuyingSteps/ChoosePay/MethodPayments/MethodPaymentTemplate';

interface SBPMethodPaymentProps extends DefaultMethodPaymentParams {
  method: SBPMethod;
  isHide?: boolean;
}

export const SBPMethodPayment: FC<SBPMethodPaymentProps> = ({
  method,
  onCheck,
  isHide = false,
  ...props
}) => {
  if (isHide) {
    return <></>;
  }

  return (
    <MethodPaymentTemplate
      Logo={(
        <SCIcon
          src="/icon/components/SBPMethodPayment/sbp.png"
        />
      )}
      Text={(
        <>
          СПБ: система быстрых платежей
        </>
      )}
      onCheck={() => {
        if (onCheck) {
          onCheck(method);
        }
      }}
      {...props}
    />
  );
};

const SCIcon = styled.img`
  width: 91px;
`;
